import React, { PropsWithChildren, ReactNode, useMemo } from "react";

import {
  ThemeProvider as MUIThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import { useSelector } from "react-redux";

import { CondominiumLayoutDTO } from "../../models/dto/CondominiumDTO";
import { AppState } from "../../store";
import lelloTheme from "../../themes/lelloTheme";

type ThemeProviderProps = PropsWithChildren<ReactNode>;

const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
}: ThemeProviderProps) => {
  const { condominiumSelected } = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  const changeDateRangePickerColor = (layout: CondominiumLayoutDTO) => {
    const root = document.querySelector(":root") as HTMLElement;
    if (root && layout.corPrimaria) {
      root.style.setProperty("--primary-color", layout.corPrimaria);
    }
  };

  const customTheme = useMemo(() => {
    let result = lelloTheme;
    const { palette: defaultPallete } = lelloTheme;
    if (condominiumSelected?.layout) {
      const { layout } = condominiumSelected;
      result = {
        ...lelloTheme,
        palette: {
          ...defaultPallete,
          primary: {
            ...defaultPallete.primary,
            main: layout.corPrimaria ?? defaultPallete.primary.main,
          },
          secondary: {
            ...defaultPallete.secondary,
            main: layout.corSecundaria ?? defaultPallete.secondary.main,
          },
        },
      };
      changeDateRangePickerColor(layout);
    }
    return createMuiTheme(result);
  }, [condominiumSelected]);

  return <MUIThemeProvider theme={customTheme}>{children}</MUIThemeProvider>;
};

export default ThemeProvider;
